<template>
  <div>

    <v-card class="pa-3 mb-3 rounded-card">
      <v-row class="spacer" align="center">
        <v-col cols="2" sm="2" md="1">
          <v-avatar>
            <!-- TODO: change image to uploaded image from BE -->
            <img
              src="https://vuetifyjs.com/apple-touch-icon-180x180.png"
              alt="Avatar"
              v-if="company.avatar"
            >
            <v-icon
              v-else
              color="black"
              x-large
            >business</v-icon>
          </v-avatar>
        </v-col>
        <v-col cols="6" sm="6" md="8">
          <div class="top-row pb-2">
            <v-row justify="space-between">
              <v-col>
                <span class="company-name">
                  {{company.name}}
                </span>
                <span v-if="company.ref != ''">
                  ({{company.ref}})
                </span>
                <v-tooltip bottom v-if="company.verified">
                  <template v-slot:activator="{ on }">
                    <v-icon color="kazan" size="18" v-on="on">verified_user</v-icon>
                  </template>
                  <span> {{$t('companies.is_verified')}}</span>
                </v-tooltip>
              </v-col>
              <v-col class="text-right" v-if="company.groups.length > 0" >
                <v-chip
                  label color="kazan_light" text-color="white"
                  v-for="(group, index) in company.groups"
                  :key="index"
                >
                  <v-icon small left>label</v-icon>{{group}}
                </v-chip>
              </v-col>
            </v-row>
          </div>
          <v-row justify="space-between" class="pt-2">
            <div>
              {{company.address.city}}, {{company.address.country}} <br>
              {{company.vat}}
            </div>
            <div>
              <v-chip
                v-for="(label, index) in company.labels"
                :key="index"
              >
                {{label}}
              </v-chip>
            </div>
          </v-row>
        </v-col>
        <v-col class="text-right" cols="3" sm="3" md="2">
          <div v-if="signedInCompany.id !== company.id">
            <v-btn
              text
              disabled
              v-if="company.ref != '' && company.verified"
            >
              {{$t('companies.connected')}}
            </v-btn>
            <v-btn
              text
              disabled
              v-else-if="company.ref != '' && !company.verified">
              {{$t('companies.managed')}}
            </v-btn>
            <v-btn
              v-else-if="company.verified"
              @click="connectDialogIsOpen = true"
            >
              {{$t('companies.connect')}}
            </v-btn>
            <v-btn
              v-if="company.ref != '' && !company.verified"
              @click="inviteDialogIsOpen = true"
            >
              {{$t('companies.invite')}}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="1" sm="1" md="1">
          <v-btn
            text
            icon
            color="kazan"
            @click="gotoCompanyDetail(company.id)"
          >
            <v-icon>launch</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <CompanyInviteDialog
      v-if="company.ref != '' && !company.verified"
      v-model="inviteDialogIsOpen"
      :company="{name: company.name, id: company.id}"
    />
    <CompanyConnectDialog
      v-if="company.ref === '' && company.verified"
      v-model="connectDialogIsOpen"
      :company="{name: company.name, id: company.id}"
    />
  </div>
</template>

<script>
import router from '@/router'
import { mapState } from 'vuex'
import CompanyInviteDialog from '@/components/companies/CompanyInviteDialog'
import CompanyConnectDialog from '@/components/companies/CompanyConnectDialog'

export default {
  name: 'CompaniesIndexListItem',
  components: {
    CompanyInviteDialog,
    CompanyConnectDialog
  },
  props: {
    company: Object
  },
  data () {
    return {
      inviteDialogIsOpen: false,
      connectDialogIsOpen: false
    }
  },
  computed: {
    ...mapState(['signedInCompany'])
  },
  methods: {
    gotoCompanyDetail (companyID) {
      router.push({ name: 'CompanyDetail', params: { companyID: companyID } })
    }
  }

}
</script>

<style lang="scss" scoped>
  .top-row {
    width: 100%;
    border-bottom: 1px solid lightgray;
  }
  .company-name {
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 5px;
    margin-bottom: 5px;
  }

  ::v-deep.v-chip .v-chip__content {
    height: 22px;
  }
</style>
